export default __webpack_public_path__ + "static/media/Web 1366 – 1.5f321432.png";